import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { NavigationService } from '../../../../core/navigation.service';
import { SearchService } from '../../../../shared/search/search.service';
import { SearchEvent } from '../../../../shared/search/models/search-event';
import { NEW_SEARCH_EVENT, REFRESH_SEARCH_EVENT } from '../../../../shared/search/search-constants';
import { SearchStatus } from '../../../../shared/search/models/search-status.model';
import { ResourceService } from 'sce-core';
import { AlertService } from 'sce-core';
import { ActivatedRoute } from '@angular/router';
import { PlatformLocation, Location } from '@angular/common';

import { SearchableEntityServiceFactory } from '../../../../shared/services/searchable-entity/searchable-entity-service-factory';
import { SearchableEntityConfig } from '../../../../shared/models/searchable-entity-config';
import { SavedSearchService } from '../../../../shared/search/saved-search.service';
import { SearchableEntityButtonService } from '../../../../shared/services/searchable-entity/searchable-entity-button.service';
import { DataTableEditorService } from '../../../../shared/search/results/data-table-editor.service';
import { TablePreference } from '../../../../shared/search/models/table-preference.model';
import { CoreServiceRegistry } from '../../../../core/core-service-registry';
import { SharedServiceRegistry } from '../../../../shared/shared-service-registry';
import { Condition, SearchCriteria } from '../../../../shared/search/models/search-filter-model';
import { Preference } from '../../../../shared/search/models/preference.model';
import { UserPreferenceEvent, DELETE_FAVOURITE, ADD_FAVOURITE } from '../../../../shared/models/user-favourite-event';
import { DATA_TABLE_LIST } from '../service/inventory-balance-tables';
import { SearchParams } from '../../../../shared/search/models/search-params.model';
import { InvLookupComponent } from '../popup/invLookup-popup.component';
import { InventoryBalanceDataService } from '../service/inv-balance-data.services';
import { DataTableConfig } from '../../../../shared/search/models/data-table-config';
import { UserPreferenceService } from '../../../../layout/home/services/user-preference.service';
import { ModalService } from '../../../../shared/services/modal.service';
// tslint:disable-next-line:max-line-length
import { ViewBalancesCellRendererComponent } from '../../../../shared/components/common/view-balances-popup/view-balances-cell-renderer/view-balances-cell-renderer.component';

@Component({
  selector: 'lfwms-inventory-balance-search',
  templateUrl: './inv-balance-search-page.component.html',
  styleUrls: ['./inv-balance-search-page.component.css']
})
export class InventoryBalanceSearchableEntitySearchComponent implements OnInit, OnDestroy {

  // The factory for all the required services
  @Input() public serviceFactory: SearchableEntityServiceFactory;
  @Output() public valueChange: EventEmitter<any> = new EventEmitter<any>();
  // The configuration object for the entity
  public entityConfig: SearchableEntityConfig;
  // helper services
  protected navService: NavigationService;
  protected resourceService: ResourceService;
  public savedSearchService: SavedSearchService;
  protected alertService: AlertService;
  protected userPreferenceService: UserPreferenceService;
  protected modalService: ModalService;

  // entity services
  public dataService: InventoryBalanceDataService;
  public buttonService: SearchableEntityButtonService;
  public dataEditor: DataTableEditorService;

  private tablePreference: TablePreference;
  public favouriteIconFlag: boolean = false;
  public expandFilterAccordion: boolean = true;
  protected expandResultsAccordion: boolean = false;
  protected filterSearchEventSubscription: Subscription;
  protected resultSearchEventSubscription: Subscription;
  protected userPreferenceEventSubscription: Subscription;
  protected resultSearchServiceEventSubscription: Subscription;

  public filterSearchService: SearchService;
  public filterSearchStatus: SearchStatus;
  private defaultFilterCriteria: SearchCriteria;

  public resultSearchService: SearchService;
  public resultSearchParams: SearchParams;
  public resultSearchStatus: SearchStatus;

  public successMsg: string = '';
  public panel: any;
  public default: any;
  public showSearchResults: any = false;
  public dataTablesList: any;

  public searchCriteriaForInv: any;
  public selectedViewType: any;


  public searchDone: boolean = false;

  public selectedData: any;
  public popupService: SearchService;
  public type: any;
  public searchStatus: any;

  public tooltipPosition: string = 'bottom';
  public tooltipMessage: string = 'Add to Favourites';

  protected searchEventSubscription: Subscription;
  public aggregateRecordsArray: any = [];
  public showAggregateSection: boolean;
  public fieldsToCalculateTotal: any = [
  'qty', 'allocated', 'picked', 'available', 'overAllocated', 'picksInProcess', 'pendingMoveIN',
  'qtyOnHold', 'qtyPreAllocated'
  ]; // [LFWM-3161] - array of fields needs to disply total in pinned row

  constructor(coreServiceRegistry: CoreServiceRegistry, private sharedServiceRegistry: SharedServiceRegistry,
    private activatedRoute: ActivatedRoute, public platformLocation: PlatformLocation,
    public location: Location) {
    this.navService = coreServiceRegistry.navigationService;
    this.resourceService = coreServiceRegistry.resourceService;
    this.userPreferenceService = coreServiceRegistry.userPreferencesService;
    this.savedSearchService = sharedServiceRegistry.savedSearchService;
    this.alertService = sharedServiceRegistry.alertService;
    this.modalService = sharedServiceRegistry.sceModalService;
  }

  public ngOnInit() {
    this.initializeProperties();
    this.dataTablesList = DATA_TABLE_LIST;
    this.activatedRoute.params.subscribe(params => {
      const searchType = params['searchType'];
      const searchId = params['searchId'];
      this.expandFilterAccordion = true;
      // if there is a search id in the route, load it
      if (searchId) {
        this.loadSavedSearchCriteria(searchId, searchType);
      } else {
        this.dataService.selectedViewType = 'invlotlocidtd';
      }
      this.loadPage();
    });
    this.dataService.setDisplayMode('V');
  }

  public subscribeForEvents() {
    this.userPreferenceEventSubscription = this.userPreferenceService.receiveEvent()
      .subscribe((event: UserPreferenceEvent) => {
        if (event.source === 'search') {
          // if this event originated from the search page, ignore it. It will be handled separately
          return;
        }
        if (event.type === DELETE_FAVOURITE) {
          this.favouriteIconFlag = false;
          // this.userPreferences.preferenceId = null;
        } else if (event.type === ADD_FAVOURITE) {
          this.favouriteIconFlag = true;
        }
      });
  }

  /**
   * Initialize the component properties
   */
  private initializeProperties() {
    this.dataService = <InventoryBalanceDataService>this.serviceFactory.getDataService();
    this.dataService.displayMode = 'V';
    this.dataEditor = this.serviceFactory.getDataEditor();
    this.buttonService = this.serviceFactory.getButtonService();
    this.entityConfig = this.dataService.getEntityConfiguration();
    this.entityConfig.initializePrimarySearchForTableId(this.dataService.selectedViewType, '');
    this.filterSearchService = this.dataService.getNewFilterSearchService();
    this.searchStatus = this.filterSearchService.searchStatus;
    this.filterSearchService.searchParams.tableEditor = this.dataEditor;
    this.filterSearchService.tableIdforTablePref = 'invsearchtd';
    this.dataService.filterSearchService = this.filterSearchService;
    this.filterSearchService.clearSavedSearchConfig(); // Clear any old data
    this.filterSearchService.searchParams.isFullFetch = true;
    this.filterSearchService.searchParams.tableId = this.dataService.selectedViewType;
    if (this.resultSearchService) {
      this.resultSearchService.searchStatus.hasResults = false;
    }
    this.filterSearchEventSubscription = this.filterSearchService.receiveEvent()
      .subscribe((event: SearchEvent) => {
        if (event.type === NEW_SEARCH_EVENT) {
          // filter search service cannot do any search. Simply delegate the call to the result search service
          this.filterSearchService.searchParams.tableId = this.dataService.selectedViewType;
          this.loadResultDataForType(this.dataService.selectedViewType);
        }
      });
  }

  private loadPage() {
    this.filterSearchService.searchParams.tableId = this.dataService.selectedViewType;
    this.filterSearchService.fetchMetadata().subscribe((metadata: any) => {
      this.filterSearchService.searchParams.tableId = this.dataService.selectedViewType;
      this.initializeUserPreferences();
    });
    this.subscribeForUserPreferenceEvents();
  }

  private loadResultDataForType(type: string) {
    this.showAggregateSection = false;
    this.resultSearchService = this.getResultSearchServiceForViewType(type);
    this.resultSearchService.searchParams.tableId = this.dataService.selectedViewType;
    this.resultSearchService.searchParams.isFullFetch = true;
    this.dataService.resultSearchService = this.resultSearchService;
    this.resultSearchParams = this.resultSearchService.searchParams;
    this.resultSearchStatus = this.resultSearchService.searchStatus;
    /* LFWM-1985 - Length Adjustment Issue -- removing hasResults = false  so as to avoid redrawing of table results when table-id is unchanged.
    it will be false when updating to new table id via dropdown and will remain true whenever new search is initiated with same tableid.
    // this.resultSearchStatus.hasResults = false;
    */
    const searchCriteriaFilter: SearchCriteria = this.dataService.filterSearchService.getSearchCriteria();
    this.resultSearchService.setSearchCriteria(searchCriteriaFilter);
    this.resultSearchService.fetchMetadata().subscribe((metadata: any) => {
      this.resultSearchParams.tableId = this.dataService.selectedViewType; // default table id for loadByPage.
      this.resultSearchParams.dataTableConfig.supportFiltering = true;
      this.resultSearchService.performSearch();

    });
    // [LFWM-1956] - method [getPinnedColumnStart] To get a column name where the pinned row should starts based on the selectedViewType [tableId]
      const pinnedColumnStart = this.getPinnedColumnStart(type);
      this.resultSearchService.searchParams.dataTableConfig.columnPinnedRendererMapping[pinnedColumnStart] = ViewBalancesCellRendererComponent;
      this.resultSearchServiceEventSubscription = this.resultSearchService.receiveEvent()
        .subscribe((event: SearchEvent) => {
          if (event.type === NEW_SEARCH_EVENT) {
            // need to clear aggregateRecordsArray for new search event
            this.aggregateRecordsArray = [];
            // [LFWM-1956] - method [getPinnedPayLoad] to create the pinned row for displaying the total based on the type [tableId]
            const pinnedPayload = this.getPinnedPayLoad(type);
            // [LFWM-1956] - this is the method where the pinned row total calculated based on type [tableId]
            const enrichPayload: any = (data: any) => {
              this.resultSearchService.pagedData.pageRows.forEach(row => {
                if (type === 'invlotlocidtd' || type === 'invblncskutd' || type === 'invskufacilitytd' || type === 'invskuloctd'
                  || type === 'invlottd' || type === 'invstorertd' || type === 'invskulocucctd' || type === 'invlotlociducctd') {
                  /* qty [onHand], allocated,  picked, available fields are needed for type invlotlocidtd, invblncskutd, invskufacilitytd,
                  invskuloctd, invlottd, invstorertd, invskulocucctd and invlotlociducctd */
                  const qty = parseInt(pinnedPayload['qty']['cVal'], 10) + parseInt(row.cells['qty'].cVal, 10);
                  pinnedPayload['qty']['cVal'] = isNaN(qty) ? 0 : qty;
                  const allocated = parseInt(pinnedPayload['allocated']['cVal'], 10) + parseInt(row.cells['allocated'].cVal, 10);
                  pinnedPayload['allocated']['cVal'] = isNaN(allocated) ? 0 : allocated;
                  const picked = parseInt(pinnedPayload['picked']['cVal'], 10) + parseInt(row.cells['picked'].cVal, 10);
                  pinnedPayload['picked']['cVal'] = isNaN(picked) ? 0 : picked;
                  const available = parseInt(pinnedPayload['available']['cVal'], 10) + parseInt(row.cells['available'].cVal, 10);
                  pinnedPayload['available']['cVal'] = isNaN(available) ? 0 : available;
                  if (type === 'invlotlocidtd') {
                    // picksInProcess, pendingMoveIN needed only for type invlotlocidtd
                    const picksInProcess = parseInt(pinnedPayload['picksInProcess']['cVal'], 10) + parseInt(row.cells['picksInProcess'].cVal, 10);
                    pinnedPayload['picksInProcess']['cVal'] = isNaN(picksInProcess) ? 0 : picksInProcess;
                    const pendingMoveIN = parseInt(pinnedPayload['pendingMoveIN']['cVal'], 10) + parseInt(row.cells['pendingMoveIN'].cVal, 10);
                    pinnedPayload['pendingMoveIN']['cVal'] = isNaN(pendingMoveIN) ? 0 : pendingMoveIN;
                  }
                  if (type !== 'invskufacilitytd' && type !== 'invlottd' && type !== 'invstorertd' && type !== 'invskulocucctd') {
                    /* overAllocated field is not needed for type invskufacilitytd, invlottd, invstorertd and invskulocucctd*/
                    const overAllocated = parseInt(pinnedPayload['overAllocated']['cVal'], 10) + parseInt(row.cells['overAllocated'].cVal, 10);
                    pinnedPayload['overAllocated']['cVal'] = isNaN(overAllocated) ? 0 : overAllocated;
                  }
                  if (type === 'invlottd') {
                    // qtyPreAllocated and qtyOnHold fields are needed only for type invlottd
                    const qtyPreAllocated = parseInt(pinnedPayload['qtyPreAllocated']['cVal'], 10) + parseInt(row.cells['qtyPreAllocated'].cVal, 10);
                    pinnedPayload['qtyPreAllocated']['cVal'] = isNaN(qtyPreAllocated) ? 0 : qtyPreAllocated;
                    const qtyOnHold = parseInt(pinnedPayload['qtyOnHold']['cVal'], 10) + parseInt(row.cells['qtyOnHold'].cVal, 10);
                    pinnedPayload['qtyOnHold']['cVal'] = isNaN(qtyOnHold) ? 0 : qtyOnHold;
                  }
                  if (type === 'invlotlociducctd') {
                    // picksInProcess and qtyOnHold fields are needed only for type invlotlociducctd
                    const picksInProcess = parseInt(pinnedPayload['picksInProcess']['cVal'], 10) + parseInt(row.cells['picksInProcess'].cVal, 10);
                    pinnedPayload['picksInProcess']['cVal'] = isNaN(picksInProcess) ? 0 : picksInProcess;
                  }
                } else if (type === 'invidtd' || type === 'invlocationtd' || type === 'invlotidtd' || type === 'invlotloctd') {
                  // for type invidtd, invlocationtda and invlotidtd, invlotloctd we need to calculate total value for qty field only.
                  const qty = parseInt(pinnedPayload['qty']['cVal'], 10) + parseInt(row.cells['qty'].cVal, 10);
                  pinnedPayload['qty']['cVal'] = isNaN(qty) ? 0 : qty;
                }else if(type === 'invlotlocidcasestd'){
                  const qty = parseFloat(pinnedPayload['qty']['cVal']) + parseFloat(row.cells['qty'].cVal);
                  pinnedPayload['qty']['cVal'] = isNaN(qty) ? 0 : qty;
                  const allocated = parseFloat(pinnedPayload['allocated']['cVal']) + parseFloat(row.cells['allocated'].cVal);
                  pinnedPayload['allocated']['cVal'] = isNaN(allocated) ? 0 : allocated;
                  const picked = parseFloat(pinnedPayload['picked']['cVal']) + parseFloat(row.cells['picked'].cVal);
                  pinnedPayload['picked']['cVal'] = isNaN(picked) ? 0 : picked;
                  const available = parseFloat(pinnedPayload['available']['cVal']) + parseFloat(row.cells['available'].cVal);
                  pinnedPayload['available']['cVal'] = isNaN(available) ? 0 : available;
                  const picksInProcess = parseFloat(pinnedPayload['picksInProcess']['cVal']) + parseFloat(row.cells['picksInProcess'].cVal);
                  pinnedPayload['picksInProcess']['cVal'] = isNaN(picksInProcess) ? 0 : picksInProcess;
                  const pendingMoveIN = parseFloat(pinnedPayload['pendingMoveIN']['cVal']) + parseFloat(row.cells['pendingMoveIN'].cVal);
                  pinnedPayload['pendingMoveIN']['cVal'] = isNaN(pendingMoveIN) ? 0 : pendingMoveIN;
                }
              });
            };
            enrichPayload(this.resultSearchService.pagedData.pageRows);
            this.resultSearchService.getPagedData().pinnedPageRows = [pinnedPayload];
            // LFWM-3509- commenting the below code, as two tableprefernce api call is going while 
            // changing the pagesize, pinning or sorting the table and getting error when done for first time.
            // this.resultSearchService.publishEvent(new SearchEvent(REFRESH_SEARCH_EVENT));
            // [LFWM-1956] - to display the column aggregate of total records which is present in the server side
            if (this.resultSearchService.pagedData.pageRows.length > 0) {
              this.showAggregateSection = true;
              const aggregateRecords = this.resultSearchService.pagedData.pageDefinition.aggregateRecords;
              // tslint:disable-next-line:forin
              for (const key in aggregateRecords) {
                if (aggregateRecords[key] !== null) {
                  this.aggregateRecordsArray.push({ 'cName': key, 'cVal': aggregateRecords[key]});
                } else {
                  this.aggregateRecordsArray.push({ 'cName': key, 'cVal': 0});
                }
              }
            }
          }
        });
  }

  private getResultSearchServiceForViewType(type: string): SearchService {
    if (type === (this.resultSearchService ? this.resultSearchService.searchParams.tableId : 'null')) {
      /*  LFWM-1985 - Inventory Balances | Length Adjustment Issue.
      - issue due to resetting of search service on every search click when table is unchanged in dropdown.
      - preference save call is sent to backend and new pref is fetched before saving causing async issues.
      - **fix--  if dropdown is unchanged, re-use existing search service for new searches so that table is not re-rendered.
            */
      return this.resultSearchService;
    }
    const searchParams: SearchParams = new SearchParams();
    searchParams.tableId = type;
    searchParams.isFullFetch = true;
    searchParams.columnCount = 10;
    const tableConfig: DataTableConfig = new DataTableConfig();
    tableConfig.supportFiltering = true;
    searchParams.dataTableConfig = tableConfig;
    const searchStatus = new SearchStatus();
    const searchService = this.sharedServiceRegistry.createSearchService(searchParams, searchStatus);
    if (this.buttonService) {
      searchParams.actionButtons = this.buttonService.getButtonsForPanel('search-table');
    }
    searchService.searchParams.tableEditor = this.dataEditor;
    if (this.resultSearchEventSubscription) {
      this.resultSearchEventSubscription.unsubscribe();
    }
    this.resultSearchEventSubscription = searchService.receiveEvent()
      .subscribe((event: SearchEvent) => {
        if (event.type === NEW_SEARCH_EVENT) {
          this.buttonService.initializeSearchPageButtons();
          this.filterSearchService.searchParams.tableId = this.dataService.selectedViewType;
          this.expandFilterAccordion = false;
          this.showSearchResults = true;
          this.expandResultsAccordion = true;
        }
      });
    return searchService;
  }

  /* This method will create new search condition */
  public createSearchCondition(i: number) {
    const searchCondition = new Condition();
    searchCondition.id = i;
    searchCondition.displayMode = 'VIEW';
    return searchCondition;
  }

  public handleViewChange(selectedViewType: string) {
    const oldValue = this.selectedViewType;
    this.selectedViewType = selectedViewType;
    this.filterSearchService.clearSavedSearchConfig();
    let selectedRows;
    if (this.resultSearchService) {
      selectedRows = this.resultSearchService.getSelectedRows();
    }
    if (selectedRows && selectedRows.length > 0) {
      if (selectedRows.length === 1) {
        this.filterSearchService.searchParams.tableId = selectedViewType;
        const mainMetadData: any = this.filterSearchService.getMetadata();
        this.filterSearchService.fetchMetadataOnly().subscribe((metaData: any) => {
          const prevType = oldValue;
          const searchParams: SearchParams = new SearchParams();
          searchParams.tableId = selectedViewType;
          searchParams.isFullFetch = true;
          const tableConfig: DataTableConfig = new DataTableConfig();
          tableConfig.supportFiltering = true;
          searchParams.dataTableConfig = tableConfig;
          const searchStatus = new SearchStatus();
          this.popupService = this.sharedServiceRegistry.createSearchService(searchParams, searchStatus);
          let title: string = '';
          for (let i = 0; i < this.dataTablesList.length; i++) {
            if (this.dataTablesList[i].key === selectedViewType) {
              title = this.dataTablesList[i].value;
            }
          }
          this.type = prevType;
          const modalRef: any = this.sharedServiceRegistry.sceModalService
            .showModal(InvLookupComponent,
              {
                overlayHeader: title,
                showHeader: true,
                overlayHeight: 520,
                overlayWidth: 1024
              });
          modalRef.content.initializeComponents(selectedRows, this.popupService, mainMetadData);
          modalRef.content.showLookup = true;
        });
      } else if (selectedRows.length > 1) {
        this.alertService.error(this.resourceService.get('err_msg_inv'));
        return;
      }
    } else {
      this.dataService.selectedViewType = selectedViewType;
      this.filterSearchService.setMetadata('');
      this.initializeProperties();
      this.loadPage();
      if (this.resultSearchService) {
        this.resultSearchService.searchStatus.hasResults = false;
      }
      this.expandFilterAccordion = true;
      this.filterSearchService.getSavedSearchConfig().searchName = null;
      this.filterSearchService.clearSavedSearchConfig();
    }
  }

  /**
   * Initialize the page based on the user preferences for the current search
   */
  private initializeUserPreferences() {
    this.tablePreference = this.filterSearchService.getTablePreference();
    const favPreference: Preference = this.tablePreference.favouriteConfig;
    if (favPreference && favPreference.configuration) {
      this.favouriteIconFlag = favPreference.configuration.favourite;
    }
  }

  /**
   * Subscribe for the search and user preference events
   */
  private subscribeForUserPreferenceEvents() {
    this.userPreferenceEventSubscription = this.userPreferenceService.receiveEvent()
      .subscribe((event: UserPreferenceEvent) => {
        if (event.source === 'search') {
          // if this event originated from the search page, ignore it. It will be handled separately
          return;
        }
        if (event.type === DELETE_FAVOURITE) {
          this.favouriteIconFlag = false;
        } else if (event.type === ADD_FAVOURITE) {
          this.favouriteIconFlag = true;
        }
      });
  }

  /**
   * If the page is loaded using a search criteria id, prepopulate the search filter
   * @param searchId - The search id
   */
  private loadSavedSearchCriteria(searchId, searchType) {
    this.filterSearchService.clearSavedSearchConfig(); // Clear any old data
    if (searchType === 'lotlocid') {
      this.filterSearchService.searchParams.tableId = 'invlotlocidtd';
      this.dataService.selectedViewType = 'invlotlocidtd';
    } else if (searchType === 'sku') {
      this.filterSearchService.searchParams.tableId = 'invblncskutd';
      this.dataService.selectedViewType = 'invblncskutd';
    } else if (searchType === 'skufacility') {
      this.filterSearchService.searchParams.tableId = 'invskufacilitytd';
      this.dataService.selectedViewType = 'invskufacilitytd';
    } else if (searchType === 'skuloc') {
      this.filterSearchService.searchParams.tableId = 'invskuloctd';
      this.dataService.selectedViewType = 'invskuloctd';
    } else if (searchType === 'id') {
      this.filterSearchService.searchParams.tableId = 'invidtd';
      this.dataService.selectedViewType = 'invidtd';
    } else if (searchType === 'location') {
      this.filterSearchService.searchParams.tableId = 'invlocationtd';
      this.dataService.selectedViewType = 'invlocationtd';
    } else if (searchType === 'lottable') {
      this.filterSearchService.searchParams.tableId = 'invlottd';
      this.dataService.selectedViewType = 'invlottd';
    } else if (searchType === 'lotid') {
      this.filterSearchService.searchParams.tableId = 'invlotidtd';
      this.dataService.selectedViewType = 'invlotidtd';
    } else if (searchType === 'lotloc') {
      this.filterSearchService.searchParams.tableId = 'invlotloctd';
      this.dataService.selectedViewType = 'invlotloctd';
    } else if (searchType === 'storer') {
      this.filterSearchService.searchParams.tableId = 'invstorertd';
      this.dataService.selectedViewType = 'invstorertd';
    } else if (searchType === 'skulocucc') {
      this.filterSearchService.searchParams.tableId = 'invskulocucctd';
      this.dataService.selectedViewType = 'invskulocucctd';
    } else if (searchType === 'lotlociducc') {
      this.filterSearchService.searchParams.tableId = 'invlotlociducctd';
      this.dataService.selectedViewType = 'invlotlociducctd';
    } else if (searchType === 'lotlocidcases') {
      this.filterSearchService.searchParams.tableId = 'invlotlocidcasestd';
      this.dataService.selectedViewType = 'invlotlocidcasestd';
    }

    // clear the search results
    this.savedSearchService.loadSearchCriteria(searchId, this.filterSearchService.getSavedSearchConfig()).subscribe((resp: any) => {
      if (resp['statusCode'] && resp['statusMessage']) {
        if (resp['statusCode'] === 200 && resp['statusMessage'] === 'SUCCESS') {
          const formattedCriteria = this.savedSearchService.transformSearchCriteriaToModel(resp, this.filterSearchService);
          if (!formattedCriteria) {
            this.alertService.error('Invalid search criteria');
            return;
          }
          this.defaultFilterCriteria = formattedCriteria;
          this.filterSearchService.setSearchCriteria(this.defaultFilterCriteria);
        }
      } else {
        if (resp.error) {
          this.alertService.clearAll();
          this.alertService.error(resp.error);
        }
      }
    }, (error) => {
      this.alertService.clearAll().error(error);
    });
  }

  // method used to translate the labels
  public getLabel(key) {
    return this.resourceService.get(key);
  }

  // add/remove favorite config
  public toggleFavourites() {
    // if the page is set as favourite, for every dropdown it should be enabled hence savig for a single table name
    if (this.favouriteIconFlag === false) {
      const userPreferences = {
        dataTableId: 'invsearchtd',
        prefType: 'FAVOURITECONFIG',
        configuration: { 'favourite': true }
      };
      this.userPreferenceService.saveTablePreferences(userPreferences).subscribe((data: any) => {
        this.favouriteIconFlag = true;
        this.tablePreference.favouriteConfig = data;
        this.notifyUserPreferenceEvent(ADD_FAVOURITE);
        this.alertService.success(this.resourceService.get('msg_fav_add'));
      }, (error: any) => {
        this.alertService.clearAll().error(this.resourceService.get(error.error.errors['0'].validationMessage));
      });
    } else {
      this.userPreferenceService.deleteFavorites(this.tablePreference.favouriteConfig.preferenceId).subscribe((data: any) => {
        this.favouriteIconFlag = false;
        this.tablePreference.favouriteConfig = null;
        this.alertService.success(this.resourceService.get('msg_fav_del'));
        this.notifyUserPreferenceEvent(DELETE_FAVOURITE);
      });
    }
  }

  private notifyUserPreferenceEvent(type: number, isExternal?: boolean) {
    const event = new UserPreferenceEvent();
    event.type = type;
    event.source = 'search';
    if (isExternal) {
      event.isExternal = isExternal;
    }
    this.userPreferenceService.notifyEvent(event);
  }

  public toggleFilterAccordion() {
    this.expandFilterAccordion = !this.expandFilterAccordion;
  }

  public toggleResultsAccordion() {
    this.expandResultsAccordion = !this.expandResultsAccordion;
  }

  /**
   * Handle the button actions on page. The call is delegated to the corresponding button service
   */
  public handleButtonPanelActions(panelId: string, action: any) {
    this.buttonService.performButtonActions(action);
  }

  // [LFWM-1956] - To get a column name where the pinned row should starts based on the selectedViewType [tableId]
  public getPinnedColumnStart(selectedViewType: string) {
    let pinnedColumnStart: string;
    if (selectedViewType === 'invlotlocidtd' || selectedViewType === 'invskufacilitytd' || selectedViewType === 'invskuloctd'
      || selectedViewType === 'invlocationtd' || selectedViewType === 'invskulocucctd' || selectedViewType === 'invlotloctd'
      || selectedViewType === 'invlotlocidcasestd') {
      pinnedColumnStart = 'facility';
    } else if (selectedViewType === 'invblncskutd' || selectedViewType === 'invlotidtd'
      || selectedViewType === 'invstorertd' || selectedViewType === 'invlotlociducctd') {
      pinnedColumnStart = 'storerKey';
    } else if (selectedViewType === 'invidtd') {
      pinnedColumnStart = 'id';
    } else if (selectedViewType === 'invlottd') {
      pinnedColumnStart = 'lot';
    }
    return pinnedColumnStart;
  }

  // [LFWM-1956] - here we are manualy creatinting the pinned row for displaying the total based on the selectedViewType [tableId]
  public getPinnedPayLoad(selectedViewType: string) {
    const pinnedPayload: any = {};
    this.filterSearchService.getMetadata().columnList.forEach((column: any) => {
      if (this.fieldsToCalculateTotal.includes(column.propertyName)) {
        pinnedPayload[column.propertyName] = { 'cName': column.propertyName, cVal: 0 };
      } else {
        pinnedPayload[column.propertyName] = { 'cName': column.propertyName, cVal: '' };
      }
    });
    pinnedPayload['isSelected'] = false;
    return pinnedPayload;
  }

  /**
   * Cleanup the subscriptions
   */
  public ngOnDestroy() {
    this.filterSearchService.setNonMandatoryConditionsCount(0);
    if (this.filterSearchEventSubscription) {
      this.filterSearchEventSubscription.unsubscribe();
    }
    if (this.resultSearchEventSubscription) {
      this.resultSearchEventSubscription.unsubscribe();
    }
    if (this.userPreferenceEventSubscription) {
      this.userPreferenceEventSubscription.unsubscribe();
    }
  }

}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/features/control/inventory-balance/search-page/inv-balance-search-page.component.ts